<template>
  <div style="width: 1200px; margin: auto">
    <div v-for="(item, index) in TendersData" :key="index">
      <!-- 轮播图 -->
      <el-row
        class="top"
        v-if="item.enable == 1 && item.number == 1"
        :gutter="15"
      >
        <el-col :span="19">
          <el-carousel height="260px">
            <el-carousel-item
              v-for="(item2, index) in item.column"
              :key="index"
            >
              <el-image
                :src="`${item2.picimg}`"
                fit="fill"
                class="serviecbanner"
              >
                <div slot="error" class="image-slot">
                  <i class="el-icon-picture-outline"></i>
                </div>
              </el-image>
            </el-carousel-item>
          </el-carousel>
        </el-col>
        <el-col :span="5">
          <div class="userInfo">
            <div class="userInfoUp">
              <div class="userInfoUpDiv" v-if="!userdata">
                <span class="line"></span>
                <span class="txt">欢迎来到辰安天泽</span>
                <span class="line"></span>
              </div>
              <div class="user_login_button" v-if="!userdata">
                <router-link to="/login"
                  ><el-button class="user-login-button">立即登录</el-button>
                </router-link>
                <router-link to="/register"
                  ><el-button class="user-register-button">免费注册</el-button>
                </router-link>
              </div>
              <div style="display: flex; align-items: center" v-if="userdata">
                <el-image class="avartarImg" :src="userdata.avatar">
                  <div slot="error" class="image-slot">
                    <i class="el-icon-picture-outline"></i>
                  </div>
                </el-image>
                <p
                  style="font-size: 14px"
                  class="tip3"
                  :title="userdata.merchantName"
                >
                  {{ userdata.merchantName }}
                </p>
              </div>
            </div>
			<!-- 这个地方是1.但为了解决采购商不能进入后台问题加上了if判断 -->
            <!--  1. <div class="userInfoDown" > -->
            <div class="userInfoDown" v-if="type == '3'">
              <p class="title">采购商服务</p>
              <div>
                <ul class="userInfoDownUl">
                  <li @click="handlemypurchase">
                    <el-image
                      style="
                        padding: 10px;
                        width: 26px;
                        height: 26px;
                        border: 1px solid #ccc;
                        border-radius: 50%;
                      "
                      :src="require('@/assets/images/mycaigou.png')"
                      fit="fill"
                    >
                      <div slot="error" class="image-slot">
                        <i class="el-icon-picture-outline"></i>
                      </div>
                    </el-image>
                    <p>我的采购</p>
                  </li>
                  <li @click="handleorder">
                    <el-image
                      style="
                        padding: 10px;
                        width: 26px;
                        height: 26px;
                        border: 1px solid #ccc;
                        border-radius: 50%;
                      "
                      :src="require('@/assets/images/ordermagengt.png')"
                      fit="fill"
                    >
                      <div slot="error" class="image-slot">
                        <i class="el-icon-picture-outline"></i>
                      </div>
                    </el-image>
                    <p>订单管理</p>
                  </li>
                </ul>

                <p class="userInfoDownP" @click="handlemypurchase(886)">
					进入买家中心>
                </p>
              </div>
            </div>
            <div class="userInfoDown" v-if="type == '1' && userdata">
              <p class="title">供应商服务</p>
              <div>
                <ul class="userInfoDownUl">
                  <li @click="handleMyOffer">
                    <el-image
                      style="
                        padding: 10px;
                        width: 26px;
                        height: 26px;
                        border: 1px solid #ccc;
                        border-radius: 50%;
                      "
                      :src="require('@/assets/images/mybaojiapng.png')"
                      fit="fill"
                    >
                      <div slot="error" class="image-slot">
                        <i class="el-icon-picture-outline"></i>
                      </div>
                    </el-image>
                    <p>我的报价</p>
                  </li>
                  <!-- <li @click="handleMyOffer">
                    <el-image
                      style="
                        padding: 10px;
                        width: 26px;
                        height: 26px;
                        border: 1px solid #ccc;
                        border-radius: 50%;
                      "
                      :src="require('@/assets/images/ordermagengt.png')"
                      fit="fill"
                    >
                      <div slot="error" class="image-slot">
                        <i class="el-icon-picture-outline"></i>
                      </div>
                    </el-image>
                    <p>订单管理</p>
                  </li> -->
                </ul>
                <a :href="`${$baseUrl}/login`" v-if="type == '1'">
                  <p class="userInfoDownP">进入卖家中心></p>
                </a>
                <a :href="`${$baseUrl}/login`" v-if="type !== '1'">
                  <p class="userInfoDownP">进入卖家中心></p>
                </a>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
      <!-- 数据板块 -->
      <div v-if="item.enable == 1 && item.number == 2">
        <el-row class="datas">
          <el-col
            class="channel-column"
            v-for="(item3, index) in item.statistics"
            :key="index + '_hot'"
          >
            <div class="datas_nav">
              <div class="data_content">
                <el-image
                  :src="require('@/assets/images/chenjmoney.png')"
                  class="bg_img"
                >
                  <div slot="error" class="image-slot">
                    <i class="el-icon-picture-outline"></i>
                  </div>
                </el-image>
                <div>
                  <p class="title">累计成交金额</p>
                  <p class="title">
                    <span>{{
                      (Number(item3.purmonery) / 10000).toFixed(2)
                    }}</span
                    >万
                  </p>
                </div>
              </div>
              <div class="spear"></div>
              <div class="data_content">
                <el-image
                  :src="require('@/assets/images/caigoudan.png')"
                  class="bg_img"
                >
                  <div slot="error" class="image-slot">
                    <i class="el-icon-picture-outline"></i>
                  </div>
                </el-image>
                <div>
                  <p class="title">采购单数</p>
                  <p class="title">
                    <span>{{ item3.purnum }}</span
                    >单
                  </p>
                </div>
              </div>
              <div class="spear"></div>
              <div class="data_content">
                <el-image
                  :src="require('@/assets/images/gongys.png')"
                  class="bg_img"
                >
                  <div slot="error" class="image-slot">
                    <i class="el-icon-picture-outline"></i>
                  </div>
                </el-image>
                <div>
                  <p class="title">入驻供应商总数</p>
                  <p class="title">
                    <span>{{ item3.mernum }}</span
                    >家
                  </p>
                </div>
              </div>
              <div class="spear"></div>
              <div class="data_content">
                <el-image
                  :src="require('@/assets/images/baojiadna.png')"
                  class="bg_img"
                >
                  <div slot="error" class="image-slot">
                    <i class="el-icon-picture-outline"></i>
                  </div>
                </el-image>
                <div>
                  <p class="title">累计报价单</p>
                  <p class="title">
                    <span>{{ item3.quonum }}</span
                    >单
                  </p>
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
        <!-- echars图 -->
      </div>
      <!-- <el-row :gutter="20" v-if="item.number == 3 && item.enable == 1">
        <el-col :span="12">
          <div class="bgc">
            <div class="operating">
              <el-image
                :src="require('@/assets/images/zoushi1.png')"
                fit="fill"
                class="operating_img"
              >
                <div slot="error" class="image-slot">
                  <i class="el-icon-picture-outline"></i>
                </div>
              </el-image>
              <h3>价格走势</h3>
            </div>
            <div id="orderNumber" class="order"></div>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="bgc">
            <div class="operating">
              <el-image
                :src="require('@/assets/images/jiagepaixu.png')"
                fit="fill"
                class="operating_img"
              >
                <div slot="error" class="image-slot">
                  <i class="el-icon-picture-outline"></i>
                </div>
              </el-image>
              <h3>价格指数</h3>
            </div>
            <template>
              <el-table
                :header-cell-style="headClass"
                :data="tableData"
                style="width: 100%; padding: 0px 20px 40px 20px"
              >
                <el-table-column prop="date" label="序号"> </el-table-column>
                <el-table-column prop="name" label="名称"> </el-table-column>
                <el-table-column prop="address" label="规格型号">
                </el-table-column>
                <el-table-column prop="address" label="产品属性">
                </el-table-column>
                <el-table-column prop="address" label="价格指数">
                </el-table-column>
              </el-table>
            </template>
          </div>
        </el-col>
      </el-row> -->
      <!-- 热门采购订单 -->
      <el-row v-if="item.number == 4 && item.enable == 1">
        <div class="bgc">
          <div class="bgc" style="padding-bottom: 20px">
            <div class="operating3" style="padding: 0px 20px">
              <div style="display: flex; justify-content: flex-start">
                <el-image
                  :src="require('@/assets/images/gonggong-remen.png')"
                  fit="fill"
                  class="operating_img"
                >
                  <div slot="error" class="image-slot">
                    <i class="el-icon-picture-outline"></i>
                  </div>
                </el-image>
                <h3>热门招标订单</h3>
              </div>
              <div class="contents">
                <h3 class="more" @click="handleMore">更多></h3>
              </div>
            </div>
            <div class="in_table_1">
              <el-row class="top">
                <el-col :span="4"><h4 class="in_table_1_left">标题</h4></el-col>
                <el-col :span="4"
                  ><h4 class="in_table_1_left">项目名称</h4></el-col
                >
                <el-col :span="5" v-if="type !== '1'"
                  ><h4 class="in_table_1_left">报名截止时间</h4>
                </el-col>
                <el-col :span="6" v-if="type == '1'"
                  ><h4 class="in_table_1_left">报名截止时间</h4>
                </el-col>
                <el-col :span="4"
                  ><h4 class="in_table_1_left">金额</h4>
                </el-col>
                <el-col :span="2" v-if="type !== '1'"
                  ><h4 class="in_table_1_left">已报价数量</h4>
                </el-col>
              </el-row>
              <div
                class="contents"
                v-for="(item5, index) in item.order"
                :key="index + '_hot'"
                @click="handleDetail(item5.id, item5.code,item5.hasQuoted,item5.mid)"
              >
                <el-row class="contents_items">
                  <el-col :span="4"
                    ><p class="tip" :title="item5.title">{{ item5.title }}</p>
                  </el-col>
                  <el-col :span="4"
                    ><p class="tip2" :title="item5.projectName">
                      {{ item5.projectName }}
                    </p>
                  </el-col>
                  <el-col :span="5" v-if="type !== '1'"
                    ><p style="padding-left: 15px">
                      {{ item5.quoteEndTime }}
                    </p></el-col
                  >
                  <el-col :span="6" v-if="type == '1'"
                    ><p style="padding-left: 15px">
                      {{ item5.quoteEndTime }}
                    </p></el-col
                  >
                  <el-col :span="4"
                    ><p style="padding-left: 15px">
                      ￥{{ item5.total == null ? 0 : item5.total }}
                    </p></el-col
                  >
                  <el-col :span="4" v-if="type !== '1'"
                    ><p style="padding-left: 15px">
                      {{ item5.quoteNum == null ? 0 : item5.quoteNum }}
                    </p></el-col
                  >

                  <el-col :span="3"><p v-if="type==='3'&&bxmId === item5.mid" class="chakan">查看</p>
                  <p v-else-if="type!='3'" class="chakan">查看</p></el-col>
                </el-row>
              </div>
            </div>
          </div>
          <!-- <el-row class="order_data" :gutter="10">
            <el-col
              class="order_list"
              :span="5"
              v-for="(item5, index) in item.order"
              :key="index + '_hot'"
            >
              <div
                class="order_item"
                @click="handleDetail(item5.id, item5.code)"
              >
                <h2>{{ item5.quoteEndTime }}</h2>
                <p>{{ item5.title }}</p>
              </div>
            </el-col>
          </el-row> -->
        </div>
      </el-row>
      <!-- 中标公告 -->
      <!-- (item.number == 4 && item.enable == 1 && !userdata) ||
          (item.number == 4 && item.enable == 1 && type == '0') -->
      <el-row v-if="item.number == 5 && item.enable == 1">
        <div class="bgc" style="padding-bottom: 20px">
          <div class="operating3" style="padding: 0px 20px">
            <div style="display: flex; justify-content: flex-start">
              <el-image
                :src="require('@/assets/images/gonggong-remen.png')"
                fit="fill"
                class="operating_img"
              >
                <div slot="error" class="image-slot">
                  <i class="el-icon-picture-outline"></i>
                </div>
              </el-image>
              <h3>中标公告</h3>
            </div>
            <h3 @click="handleWinningMore()" class="more">更多></h3>
          </div>
          <div class="in_table_1">
            <el-row class="top">
              <el-col :span="4"><h4 class="in_table_1_left">标题</h4></el-col>
              <el-col :span="6"
                ><h4 class="in_table_1_left">项目名称</h4></el-col
              >
              <el-col :span="6"
                ><h4 class="in_table_1_left">中标时间</h4>
              </el-col>
              <el-col :span="8"
                ><h4 class="in_table_1_left">中标公司</h4>
              </el-col>
            </el-row>
            <div
              class="contents"
              v-for="(item6, index) in item.order"
              :key="index + '_hot'"
              @click="handleWinningItem(item6.winningUid, item6.id, item6.code,item6.mid)"
            >
              <el-row class="contents_items">
                <el-col :span="4"
                  ><p class="tip" :title="item6.title">{{ item6.title }}</p>
                </el-col>
                <el-col :span="6"
                  ><p class="tip2" :title="item6.projectName">
                    {{ item6.projectName }}
                  </p>
                </el-col>
                <el-col :span="6"
                  ><p style="padding-left: 15px">
                    {{ item6.finishTime }}
                  </p></el-col
                >
                <el-col :span="4"
                  ><p style="padding-left: 15px">
                    {{ item6.winningName }}
                  </p></el-col
                >
                <el-col :span="4"><p v-if="type==='3'&&bxmId === item6.mid" class="chakan">查看</p>
                  <p v-else-if="type!='3'" class="chakan">查看</p></el-col>
              </el-row>
            </div>
          </div>
        </div>
      </el-row>
    </div>
  </div>
</template>
<script>
import { Tenderslist, helpArticle_list } from "@/api/xunyou";
import * as echarts from "echarts";
export default {
  name: "procurementTenders",
  data() {
    return {
      articleList: [],
      bxmId: JSON.parse(localStorage.getItem("userdata"))
        ? JSON.parse(localStorage.getItem("userdata")).bxmId
        : "",
      userdata: JSON.parse(localStorage.getItem("userdata")),
      type: JSON.parse(localStorage.getItem("userdata"))
        ? JSON.parse(localStorage.getItem("userdata")).type
        : "3", //1-供应商，2-普通店铺，3-采购商
      TendersData: [],
      loading: true,
      activeName: "1",
      formInline: {
        pageSize: 10,
        pageNum: 1,
        categoryId: 7,
      },
      tableData: [
        {
          date: "2016-05-02",
          name: "王一博",
          address: "河南省",
        },
        {
          date: "2016-05-04",
          name: "王一博",
          address: "河南省",
        },
        {
          date: "2016-05-01",
          name: "王一博",
          address: "河南省",
        },
        {
          date: "2016-05-03",
          name: "王一博",
          address: "河南省",
        },
        {
          date: "2016-05-03",
          name: "王一博",
          address: "河南省",
        },
      ],
    };
  },
  mounted() {},
  created() {
    console.log(this.userdata.userId, "userdata");
    this.getHelpArticle_list();
    this.handelData();
  },
  methods: {
    //中标公告更多
    handleWinningMore() {
      if (!this.userdata || this.type == "0") {
        this.$message({
          type: "info",
          message: "请确认您是否登录或者是个人账号",
        });
      } else {
        // 1是供应商 3是采购商
        if (this.type == 3) {
          this.$router.push("/mypurchase"); //采购商入口
        } else if (this.type == 1) {
          this.$router.push("/procurementList"); //供应商入口
        }
      }
    },
    //中标公告数据查看
    //  :to="`/siteHelpDetail?itemId=${item.articleId}`"
    handleWinningItem(winningUid, id, code, mid) {
      // console.log(winningUid,"userId",this.userdata.userId,"usedata");
      if(this.type === '3'){
        if(this.bxmId != mid){
          return false;
        }
      }
      if (!this.userdata || this.type == "0") {
        this.$message({
          type: "info",
          message: "请确认您是否登录或者是个人账号",
        });
      } else {
        //供应商限制
        if (this.type == 1) {
          if (winningUid == this.userdata.userId) {
            this.$router.push(`/procurementDetails?id=${id}&code=${code}`);
          } else {
            this.$message({
              type: "info",
              message: "非中标公司不可查看",
            });
          }
        }
        //采购商不做限制
        if (this.type == 3) {
          this.$router.push(`/CorderDetails?id=${id}`);
        }
      }
    },
    //我的报价
    handleMyOffer() {
      if (this.userdata) {
        if (this.type == "1") {
          this.$router.push("/procurementList");
        } else if (this.type == "0") {
          //个人账号
          this.$router.push("/welcomesystem");
        }
      } else {
        this.$router.push("/login");
      }
    },
    //订单管理
    handleorder() {
      if (this.userdata) {
        if (this.type == "3") {
          this.$router.push("/mypurchaseRight");
        } else if (this.type == "0") {
          //个人账号

          this.$router.push("/welcomesystem");
        }
      } else {
        this.$router.push("/login");
      }
    },
    //我的采购
    handlemypurchase(e) {
		// if (e == '886') {
		// 	window.location.href = `${this.$baseUrl}/index`;
		// 	return
		// }
		// console.log("看到我说明没有return出去。错误的！");
      if (this.userdata) {
        if (this.type == "3") {
          this.$router.push("/mypurchase");
        } else if (this.type == "0") {
          //个人账号
          this.$router.push("/welcomesystem");
        }
      } else {
        this.$router.push("/login");
      }
    },
    handleClick() {},
    //查询数据
    handelData() {
      this.loading = false;
      if (this.bxmId == undefined) {
        this.bxmId = "";
      }
      Tenderslist({ bxmId: this.bxmId }).then((res) => {
        if (res.code == 0) {
          // enable=1 开  =2 关
          this.TendersData = res.rows;
          console.log(res.rows)

          this.$nextTick(() => {
            //再dom创建出来再绘图
            // this.order();
          });
        }
      });
    },
    // 文章列表接口
    getHelpArticle_list() {
      helpArticle_list({ articleType: 3 })
        .then((res) => {
          if (res.code == 0) {
            this.articleList = res.rows.slice(0, 5);
          } else {
            this.$message({
              type: "info",
              message: res.msg,
            });
          }
        })
        .catch((err) => {
          this.$message.error("获取文章列表失败，请稍后再试！");
        });
    },
    //价格走势
    order() {
      var myChart = echarts.init(document.getElementById("orderNumber"));
      myChart.setOption({
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: ["10-25", "10-26", "10-27", "10-28", "10-29"],
          axisTick: {
            show: false,
          },
        },
        tooltip: {
          trigger: "axis",
        },
        yAxis: {
          type: "value",
          splitLine: {
            show: true,
            lineStyle: {
              //设置网格线为虚线
              type: "dashed",
            },
          },
        },
        grid: {
          //设置图的高度
          height: 260,
        },
        series: [
          {
            data: [1, 5, 2, 14, 18],
            type: "line",
            smooth: true, //平滑线
            symbol: "none", //去掉圆点
            areaStyle: {
              normal: {
                //  颜色渐变函数 前四个参数分别表示四个位置依次为左、下、右、上
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {
                    offset: 0,
                    color: "rgba(198, 82, 63,0.5)",
                  },

                  {
                    offset: 1,
                    color: "rgba(198, 82, 63,0)",
                  },
                ]),
              },
            },
            itemStyle: {
              normal: {
                color: "rgb(198, 82, 63)",
                shadowBlur: 8,
                shadowColor: "pink",
                borderColor: "blue",
                borderWidth: 2,
                backgroundColor: "transparent",
              },
            },
          },
        ],
      });
      window.addEventListener("resize", () => {
        myChart.resize();
      });
    },
    // 表头样式设置
    headClass() {
      return "background:#eef1f6;color:black";
    },
    //更多
    handleMore() {
      if (!this.userdata || this.type == "0") {
        this.$message({
          type: "info",
          message: "请确认您是否登录或者是个人账号",
        });
      } else {
        // 1是供应商 3是采购商
        if (this.type == 3) {
          this.$router.push("/mypurchase"); //采购商入口
        } else if (this.type == 1) {
          this.$router.push("/procurementList"); //供应商入口
        }
      }
    },
    //详情
    handleDetail(id,code,hasQuoted,mid) {
      if(this.type === '3'){
        if(this.bxmId != mid){
          return false;
        }
      }


      if (!this.userdata || this.type == "0") {
        this.$message({
          type: "info",
          message: "请确认您是否登录或者是个人账号",
        });
      } else {
        if (this.type == 1) {
          //供应商
          this.$router.push(`/procurementDetails?id=${id}&code=${code}&hasQuoted=${hasQuoted}`);
        } else if (this.type == 3) {
          //采购商
          this.$router.push(`/CorderDetails?id=${id}`);
        }
      }
    },
  },
};
</script>
<style lang="less" scoped>
.tip {
  width: 180px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.tip2 {
  width: 100px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.tip3 {
  width: 150px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.in_table_1 {
  border: 1px solid #eee;
  display: block;
  margin: 25px 40px;
  .top {
    padding-left: 40px;
  }
  .in_table_1_left {
    font-size: 16px;
    color: #000000;
    line-height: 55px;
    font-weight: bold;
  }

  .contents {
    cursor: pointer;
    height: 46px;

    .contents_items {
      background: #eee;
      p {
        line-height: 46px;
        font-size: 14px;
        color: #000000;
        padding-left: 40px;
        height: 46px;
      }
    }
  }
  .contents_items:hover {
    background-color: white;
  }
  // thead{
  //   tr{
  //     td{
  //       font-size: 16px;
  // color: #000000;
  // line-height: 55px;
  // font-weight: bold;
  // padding-left: 40px;
  //     }
  //   }
  // }
}
.avartarImg {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  margin-right: 20px;
  margin-top: 10px;
  margin-left: 10px;
  border: 1px solid #dadada;
}
.top {
  margin-top: 10px;
  .serviecbanner {
    width: 1200px;
    height: 260px;
  }
  .userInfo {
    height: 260px;
    background: #fff;

    .userInfoUp {
      // border-bottom: 1px dashed #a6b4ce;
      .userInfoUpDiv {
        padding: 15px 20px 10px 20px;

        text-align: center;
        .line {
          display: inline-block;
          width: 20px;
          border-top: 1px solid #dae0eb;
        }
        .txt {
          margin: 0 5px;
          font-size: 16px;
          color: #262626;
          vertical-align: -4px;
        }
      }
      .user_login_button {
        padding: 0px 20px !important;
        display: flex;
        justify-content: space-between;
        margin-bottom: 5px;
        .user-login-button {
          padding: 9px 15px !important;
          background: #c6523f;
          color: #fff;
        }
        .user-register-button {
          padding: 9px 15px !important;
          border: 1px solid #c6523f;
          background: #fff;
          color: #c6523f;
        }
      }
    }
    .userInfoDown {
      padding: 10px 20px;
      padding-top: 0;
      .title {
        height: 50px;
        line-height: 50px;
        color: rgb(198, 82, 63);
        text-align: center;
        font-size: 16px;
      }
      .userInfoDownUl {
        overflow: hidden;
        li {
          float: left;
          cursor: pointer;
          margin: 0 23px;
          font-size: 13px;
          color: #262626;
        }
      }
      .userInfoDownP {
        margin: 5px;
        font-size: 13px;
        color: #c6523f;
        margin-top: 30px;
        text-align: center;
        cursor: pointer;
      }
    }
  }
}
/deep/.el-tabs__item.is-active {
  color: #c6523f;
}
/deep/.el-tabs--border-card > .el-tabs__header .el-tabs__item {
  font-size: 14px;
}
/deep/.el-tabs__item:hover {
  color: #c6523f;
}
/deep/ .el-tabs__active-bar {
  background-color: #c6523f;
}
.spear {
  margin: 0 35px;
  overflow: hidden;
  width: 1px;
  height: 55px;
  background-color: #ccc;
}
.datas {
  margin-top: 20px;
  background-color: #fff;
  .channel-column {
    width: 1200px;
    height: 100px;
    margin-left: 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .spear {
      overflow: hidden;
      width: 1px;
      height: 55px;
      background-color: #ccc;
    }

    .title {
      width: 88px;
      color: gray;
      font-size: 12px;
      span {
        color: #000;
        font-weight: bold;
        font-size: 18px;
        margin-right: 8px;
      }
    }
  }

  .datas_nav {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .data_content {
      margin: 0 38px;
      display: flex;
      align-items: center;
      .bg_img {
        width: 65px;
        height: 65px;
        border-radius: 50%;

        margin-right: 10px;
      }
    }
  }
}
.bgc {
  padding-top: 5px;
  margin-top: 20px;
  background: #fff;
  background-color: rgba(255, 255, 255, 1);
  .operating_img {
    margin: 15px;
    width: 20px;
    height: 20px;
  }
  h3 {
    margin-top: 10px;
    font-size: 20px;
    font-weight: bold;
  }
  .operating {
    display: flex;
    justify-content: flex-start;
  }
  .operating3 {
    margin-left: -15px;
    display: flex;
    justify-content: space-between;
    .more {
      cursor: pointer;
    }
  }
}
.table_zhaobiao {
  border: 1px solid #eee;
  display: block;
  margin: 10px 40px;
  h4 {
    font-size: 16px;
    color: #000000;
    line-height: 55px;
    font-weight: bold;
    padding-left: 40px;
  }
}
.order {
  margin-top: -50px;
  width: 590px;
  height: 376px !important;
}
.order_data {
  padding: 10px 40px;
  padding-bottom: 30px;

  .order_list {
    width: 260px;
    height: 100px;
    margin: 10px;
    box-shadow: 0px 0px 4px 2px rgba(123, 123, 123, 0.22);
  }

  .order_item {
    padding: 10px;
    h2 {
      height: 30px;
      line-height: 30px;
    }
    p {
      color: gray;
    }
  }
  .order_list:hover {
    cursor: pointer;
    border: 1px solid rgb(198, 82, 63);
    box-shadow: 0px 0px 4px 2px rgba(123, 123, 123, 0.22);
  }
  .order_list:hover h2 {
    color: gray;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/procurementTenders/index.vue